import { createElement } from 'react'

type RenderHTMLType = {
  rawHTML: string
  className?: string
}
export const renderHTML = ({rawHTML, className = ""}: RenderHTMLType) => createElement("span", { className: className, dangerouslySetInnerHTML: { __html: rawHTML } })
